/*global $*/
import moment from "moment";

import { authentication, database, logOut, fbDbRefs } from "./app-database";
import { callService } from "./tools";
import { getClientInfo } from './movil/polizas/pagoPorKilometro.act';

const urlRetenedores = "registro.consultaRetenedores";

export const conectarFirebase = ($ngRedux, bMovil) => {
	return new Promise((resolve, reject) => {
		if (!$ngRedux.getState().global.stateInitialized && !authentication.currentUser.isAnonymous) {
			let sClienteUnico = $ngRedux.getState().global.clienteUnico;
			let fchHoy = new Date().toISOString().split("T")[0].split("-").join("");
			var valueShowRetenedores;
			database.ref(`retenedoresAdc/`).child('show').once("value")
			.then( (referenciaSnapshot) => {
				valueShowRetenedores = referenciaSnapshot.val();
			})

			function checkingRetenedores(generales){
				new callService({
					service: urlRetenedores,
					secure: true,
					data: {
						numPoliza: generales.numPoliza
					}
				}).execute().then((respuesta) => {
					generales.viaNomina = respuesta.pagoViaNomina;
				}).catch((error) => {
					console.error(error);
					generales.viaNomina = false;
				});
			}
			// Acceso familiar
			var accesoFamiliarRef = database.ref("acceso-familiar/" + authentication.currentUser.uid);
			fbDbRefs.push(accesoFamiliarRef);
			accesoFamiliarRef.on("value", snapshot => {
				let data = snapshot.val();
				let listaFamiliares = [];

				if (data != null)
					Object.keys(data).map((item, i) => {
						let pendiente = true, polizas = [];
						data[item].id = item;

						if (!data[item].polizas) {
							data[item].polizas = polizas; pendiente = false;
						} else {
							let dataPolizas = data[item].polizas;

							Object.keys(dataPolizas).map((item) => {
								polizas.push(item);
								if (dataPolizas[item] == false) {
									pendiente = false;
								}
							});
						}

						data[item].polizas = polizas;
						data[item].pendiente = pendiente;
						listaFamiliares.push(data[item]);
					});

				$ngRedux.dispatch({ "type": "AF_LISTA_FAMILIARES", "listaFamiliares": listaFamiliares });
			});

			var polizasRef = database.ref("polizas/" + authentication.currentUser.uid);
			fbDbRefs.push(polizasRef);
			polizasRef.on("value", snapshot => {
				let response = snapshot.val();

				if (response != null) {

					let polizasAutos = [];
					let promisesAutos = [];
					if (response.autos) {
						if (response.autos.length > 0) {
							response.autos.forEach((poliza) => {
								let { generales } = poliza;
								if( valueShowRetenedores === true){
									checkingRetenedores(generales);
								}
								if (generales.cveProdTecnico !== "A2400AUTG") {
									polizasAutos.push(poliza);
								} else if (generales.cveProdComercial !== "00001") {
									polizasAutos.push(poliza);
								} else if (generales.cveProdTecnico === "A2400AUTG" && (generales.cveProdComercial === "00001" || generales.cveProdComercial === "00003")) {
									polizasAutos.push(poliza);
								}
								promisesAutos.push(new Promise((resolve) => {
									return database.ref("referencias/").child(generales.numPoliza).once('value').then((referenciaSnapshot) => {
										var referencia = referenciaSnapshot.val();
										if (referencia){
											let index = polizasAutos.findIndex((p) => p.generales.numPoliza == generales.numPoliza);
											polizasAutos[index].generales.referenciaOriginal = referencia.referencia;
										}										
										resolve();
									},()=>{
										resolve();
									});
								}));
							});
						}
					}

					let polizasVida = [];

					if (response.vida) {
						if (response.vida.length > 0) {
							response.vida.forEach((poliza) => {
								let { generales } = poliza;
								if( valueShowRetenedores === true){
									checkingRetenedores(generales);
								}
								if (generales.cveProdTecnico !== "V1011ATRAD") {
									polizasVida.push(poliza);
								} else if (generales.cveProdComercial !== "00002") {
									polizasVida.push(poliza);
								}
							});
						}
					}

					let polizasDanios = [];

					if (response.danios) {
						if (response.danios.length > 0) {
							response.danios.forEach((poliza) => {
								let { generales } = poliza;
								if( valueShowRetenedores === true){
									checkingRetenedores(generales);
								}
								if (generales.cveProdTecnico !== "D0500LEMUR") {
									polizasDanios.push(poliza);
								} else if (generales.cveProdComercial !== "00002") {
									polizasDanios.push(poliza);
								}
							});
						}
					}

					const polizasGmm = [];

					if (response.gmm) {
						if (response.gmm.length > 0) {
							response.gmm.forEach((poliza) => {
								const { generales } = poliza;
								if( valueShowRetenedores === true){
									checkingRetenedores(generales);
								}
								polizasGmm.push(poliza);
							});
						}
					}
					//Hace el dispatch despues de buscar todas las polizas
					Promise.all(promisesAutos)
						.then(() => {
							$ngRedux.dispatch({
								"type": "POLIZAS_LLENAR",
								"autos": polizasAutos,
								"gm": polizasGmm.length > 0 ? response.gmm : [],
								"vida": polizasVida,
								"danios": polizasDanios,
								"ts": response.ts
							});
						},(error)=>{
							console.log(error);
						});

					let autos = response.autos ? response.autos : [];

					let p = [];

					let listaPolizas = [];

					autos.map((item, i) => {

						p.push(getClientInfo(
							item.generales.numPoliza,
							item.generales.numVersion
						));

						if (item.generales && (item.generales.claveRol == "TOM" || (item.generales.claveRol == "COH" && item.generales.cveClasificacionSeguro == "05"))) {
							let fchVigencia = item.generales.fchVigenciaFinal.split("/").reverse().join("");
							if (fchHoy < fchVigencia) {
								listaPolizas.push(item);
							}
						}
					});

					Promise.all(p).then(response => {

						let obj = {};

						autos.forEach((item, i) => {

							obj[item.generales.numPoliza] = response[i];

						});
						$ngRedux.dispatch({
							type: 'SET_PXK',
							pagoPorKilometro: obj
						});
					});

					$ngRedux.dispatch({ "type": "AF_LISTA_POLIZAS", "listaPolizas": listaPolizas });

					if (listaPolizas.length == 0) {
						$ngRedux.dispatch({ "type": "AF_SIN_POLIZAS", "sinPolizas": true });
					}

					if (bMovil) {
						window.localStorage.setItem("polizas", JSON.stringify($ngRedux.getState().polizas));
					}

					resolve(true);
				} else {
					if (window.location.href.indexOf("home") != -1) {
						$("#modal-bienvenido").modal();
					}
					$ngRedux.dispatch({
						"type": "POLIZAS_LLENAR",
						"autos": [],
						"gm": [],
						"vida": [],
						"danios": [],
						"ts": (new Date()).getTime()
					});
				}
			});

			var cobranzaRef = database.ref("cobranza/liquidacion/" + authentication.currentUser.uid);
			fbDbRefs.push(cobranzaRef);
			cobranzaRef.on("value", snapshot => {
				let pagos = [], response = snapshot.val();

				if (response != null) {
					Object.keys(response).map((item) => {
						pagos.push(response[item]);
					});
					$ngRedux.dispatch({ "type": "HISTORICO_PAGOS_LLENAR", "historicoPagos": pagos });
				}
			});

			var sesionRef = database.ref("sesion/" + authentication.currentUser.uid);
			fbDbRefs.push(sesionRef);
			sesionRef.on("value", snapshot => {
				let response = snapshot.val();

				dataLayer.push({
					'event': 'evLogin',
					'genero': 'NA',
					'edad': 'NA',
					'userID': authentication.currentUser.uid
				});
				if (response != null)
					$ngRedux.dispatch({
						"type": "CARGAR_SESION",
						"nombre": response.nombre,
						"lastlogin": moment.utc(response.lastlogin, "YYYY-MM-DD HH:mm:ss").local().format("DD/MM/YYYY HH:mm")
					});
			});

			var portalesRef = database.ref("portales/" + authentication.currentUser.uid);
			fbDbRefs.push(portalesRef);
			portalesRef.on("value", snapshot => {
				let response = snapshot.val();

				if (response != null) {
					if (response.cerrar) {
						logOut();
					}
				}
			});

			// Catalogo de preguntas secretas
			var preguntasRef = database.ref("preguntas");
			fbDbRefs.push(preguntasRef);
			preguntasRef.on("value", snapshot => {
				let data = snapshot.val();

				$ngRedux.dispatch({
					"type": "CARGAR_CATALOGO_PREGUNTAS",
					"catalogoPregunta1": data.pregunta1,
					"catalogoPregunta2": data.pregunta2
				});
			});

			// Version de la aplicacion
			var versionRef = database.ref("version");
			fbDbRefs.push(versionRef);
			versionRef.on("value", snapshot => {
				var localVersion = window.localStorage.getItem("version");
				if (localVersion != snapshot.val()) {
					window.localStorage.setItem("version", snapshot.val());
					location.reload(true);
				}
			});

			$ngRedux.dispatch({ "type": "INITIALIZE_STATE" });

			// Listado de polizas
			let llamadaSeguro = new callService({
				service: "polizas.listado",
				"secure": true,
				data: {}
			}).execute().catch(error => {
				console.log(error);
			});

			$ngRedux.dispatch({ "type": "REFRESH_TOKEN", "refreshToken": localStorage.getItem("refreshToken") });
		}
	});
};



// WEBPACK FOOTER //
// ./src/app-persistance.js